module.exports = __webpack_public_path__ + "img/Abriefhistory_Single_Frame0001.cbceaece.png";